import { render, staticRenderFns } from "./LoadMoreMessage.vue?vue&type=template&id=06402732"
import script from "./LoadMoreMessage.vue?vue&type=script&lang=js"
export * from "./LoadMoreMessage.vue?vue&type=script&lang=js"
import style0 from "./LoadMoreMessage.vue?vue&type=style&index=0&id=06402732&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports